var map = {
	"./bs.json": "Dy42",
	"./cs.json": "JPnw",
	"./da.json": "vloY",
	"./de.json": "8a2w",
	"./en.json": "janJ",
	"./es.json": "xgqX",
	"./et.json": "yWEr",
	"./fi.json": "b0P5",
	"./fr.json": "jJRe",
	"./gr.json": "3BGB",
	"./hr.json": "YUrR",
	"./hu.json": "kKJ7",
	"./it.json": "QiAZ",
	"./lt.json": "aL0o",
	"./lv.json": "UNuG",
	"./nl.json": "8zyA",
	"./no.json": "Z5ok",
	"./pl.json": "tkNt",
	"./pt.json": "ql+Q",
	"./ro.json": "3Al0",
	"./ru.json": "H6vh",
	"./sk.json": "ThTx",
	"./sl.json": "l7ot",
	"./sq.json": "6u8U",
	"./sr.json": "+bcn",
	"./sv.json": "tTxM",
	"./tr.json": "WLX3",
	"./uk.json": "hxWK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JXuf";


//////////////////
// WEBPACK FOOTER
// ./static/locales [A-Za-z0-9-_,\s]+\.json$/
// module id = JXuf
// module chunks = 15